var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-5"},[_c('b-row',[_c('b-col',[_c('h2',[_vm._v("Navigator View")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }